import { schema } from "normalizr";

export const expositionPreviewSchema = new schema.Entity("expositionPreviews");
export const expositionSchema = new schema.Entity("expositions");
